module.exports = __webpack_public_path__ + "img/icon-letter-g.f17babe3.svg";